// extracted by mini-css-extract-plugin
export default {"container":"TechnologiaDetails_container__VdSlR","stage":"TechnologiaDetails_stage__FeSig","btn_zamknij":"TechnologiaDetails_btn_zamknij__2hvAY"};